export default {
	logs: {
		log: "Журнал:",
		apps: "Програми",
		tasksAndInstruments: "Завдання та інструменти",
		updates: "Оновлення",
		server: "Сервер:",
		app: "Програма:",
		period: "Період:",
		periodNotSelect: "Період не обраний",
		refresh: "Оновити",
		lastSelected: "Останній вибір",
		reverseOrder: "Зворотній порядок",
		savePeriod: "Зберігати період",
		withCoef: "З коефіцієнтом",
		lastSelectNotFound: "Попереднього вибору не знайдено"
	},
	processes: {
		server: "Сервер:",
		stop: "Зупинити",
		view: "Вигляд",
		compact: "Оптимальний",
		full: "Повний",
		saveFile: "Зберегти файл",
		autoRefresh: "Автооновлення",
		thisActionStopProcessWantToContinue: "Ця дія зупинить цей процес. Продовжити?",
		attention: "Увага",
		cancel: "Скасувати",
		sec: "сек",
		refresh: "Оновлення"
	},
	services: {
		server: "Сервер:",
		start: "Запуск",
		restart: "Перезапуск",
		stop: "Зупинити",
		willStart: "запустить",
		willRestart: "перезапустить",
		willStop: "зупинить",
		thisAction: "Ця дія",
		thisServicesContinue: "ці сервіси. Продовжити?",
		thisServiceContinue: "цей сервіс. Продовжити?",
		attention: "Увага",
		cancel: "Скасувати",
		operation: "Операція",
		completeSuccess: "виконана успішно.",
		softSign: "ь",
		whenOperationPerforming: "При виконанні операції",
		errorOccured: "сталася помилка.",
		diffStatusesOfServicesError: "Неможливо зробити масову операцію з сервісами різного статусу",
	}
};
